import React, { useEffect, useState } from 'react';
import useDeviceDetection from '@/hooks/useDeviceDetection';
import { useGlobalStore } from '@/store';

const DesktopProgress = (): JSX.Element => {
  const [completedSteps, setCompletedSteps] = useState<string[]>([]);
  const [activeStep, setActiveStep] = useState('');
  const device = useDeviceDetection();
  const { activeView } = useGlobalStore();

  const steps = [
    {
      step: 'details',
      title: 'Enter your details',
    },
    {
      step: 'offer',
      title: 'Choose an offer',
    },
    {
      step: 'kyc',
      title: 'Complete loan steps',
    },
    {
      step: 'payment',
      title: 'Complete payment',
    },
  ];

  const getCompletedSteps = (): string[] => {
    if (activeView === 'EMI_PLANS') {
      return ['details'];
    }

    if (['SELFIE_KYC', 'DIGILOCKER_SUCCESS', 'E_MANDATE_SUCCESS'].includes(activeView)) {
      return ['details', 'offer'];
    }

    if (activeView === 'PAYMENTS') {
      return ['details', 'offer', 'kyc'];
    }
    return [];
  };

  const getActiveStep = (): string => {
    if (activeView === 'DETAILS' || activeView === 'EMPLOYER_DETAILS') {
      return 'details';
    }

    if (activeView === 'EMI_PLANS') {
      return 'offer';
    }

    if (activeView === 'PAYMENTS') {
      return 'payment';
    }

    if (['SELFIE_KYC', 'DIGILOCKER_SUCCESS', 'E_MANDATE_SUCCESS'].includes(activeView)) {
      return 'kyc';
    }

    return '';
  };

  useEffect(() => {
    setCompletedSteps(getCompletedSteps());
    setActiveStep(getActiveStep());
  }, [activeView]);

  if (device === 'Desktop' && activeView !== 'LANDING')
    return (
      <div className="mt-20 checkoutV2:mt-8 flex flex-col items-start relative progressbar px-1">
        {steps.map((step, index) => {
          return (
            <div className="mb-8 flex items-center last:mb-0 step" key={index}>
              <div
                className={`bullet w-4 h-4 border border-white-normal mr-2 rounded-full after:content-[''] after:h-10 after:last-hidden after:top-full relative after:absolute after:w-px after:left-1/2 after:-translate-x-1/2 after:bg-white-normal ${
                  completedSteps.includes(step.step) ? 'completed' : ''
                } ${activeStep === step.step ? 'border-4' : ''}`}
              />
              <div
                className={`font-normal text-base text-white-normal ${
                  activeStep === step.step ? 'text-opacity-100 font-semibold' : 'text-opacity-48'
                }`}
              >
                {step.title}
              </div>
            </div>
          );
        })}
      </div>
    );
  return <></>;
};

export default DesktopProgress;
